/* eslint-disable import/no-anonymous-default-export */
import axios from './axios';
import { LabelPosition, TimeSpan, Video } from './sessionModels';
import { SessionInput } from './sessions';

const SESSIONS = `${process.env.REACT_APP_PORTAL_URL}/api/v1/sessions`;

export enum EventType {
  LineupChange = 'LINEUP_CHANGE',
  YellowCard = 'YELLOW_CARD',
}

export enum EventReason {
  Substitution = 'SUBSTITUTION',
  RedCard = 'RED_CARD',
  Injury = 'INJURY',
}

export enum EventPlayerType {
  Keeper = 'KEEPER',
  Player = 'PLAYER',
}

export type LabelPositionInput = {
  classType: string;
  videoTime: TimeSpan;
  x: number;
  y: number;
  z: number;
};

export type Pitch = {
  id: number;
  name: string;
  type?: string | null;
  fieldLength: number;
  fieldWidth: number;
};

export type SessionUpdate = SessionInput;

export default {
  addLabelPosition(sessionId: number | string, input: LabelPositionInput): Promise<LabelPosition> {
    return axios.post(`${SESSIONS}/${sessionId}/label-positions`, input);
  },
  deleteLabelPositions(sessionId: number | string, ids: number[]) {
    return Promise.all(ids.map((id) => axios.delete(`${SESSIONS}/${sessionId}/label-positions/${id}`)));
  },
  getPitch(id: number | string): Promise<Pitch> {
    return axios.get(`${process.env.REACT_APP_PORTAL_URL}/api/v1/pitches/${id}`);
  },
  updateCalibrationImage(videoId: number | string, image: string) {
    return axios.post(`${SESSIONS}/videos/${videoId}/calibration-image`, { image });
  },
  getMatchingVideo(videoId: number | string): Promise<Video | null> {
    return axios.get(`${SESSIONS}/videos/${videoId}/matching`);
  },
  importOptaF7(sessionId: number | string, xml: string) {
    return axios.post(`${SESSIONS}/${sessionId}/opta-f7`, { xml });
  },
};
